<template>
    <div>
  
      <template v-if="booking">
        
        <!-- <h1>Your booking reference number is #{{ booking.booking_ref }}</h1> -->
        <h1>Thanks for paying balance {{ booking.customer.first_name }}</h1>
        <p>We are processing your payment and a confirmation will be sent to {{ booking.customer.email }}. Please check your spam folder if it does not arrive within one working day.</p>
  
        <!-- <h2>Your documents</h2>
        <ul>
          <li><a :href="invoice" target="_blank">Confirmation invoice</a></li>
          <li><a href="#" target="_blank">ATOL Certificate</a></li>
          <li><a href="#" target="_blank">Airline confirmation</a></li>
        </ul> -->
  
  
        <!-- <h2>Thanks for your payment</h2>
  
        <p>We have succesfully received your payment of {{ payment.payment_amount | formatCurrency }}.</p> -->
  
      </template>
  
      <template v-else>
        <h1>Thanks for paying balance.</h1>
        <p>A confirmation of this payment has been sent to the email address you provided. Please check your spam folder if it does not arrive within 10 minutes.</p>
      </template>
      <button class="btn btn-sm btn-primary" v-on:click="redirectMyBooking()">Go To Booking</button>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'Confirmation',
    data () {
      return {
        payment: null,
        booking: null
      }
    },
    // computed: {
    //   invoice: function() {
    //     return this.$root.$api + 'bookings/document/' + this.booking.id + '-invoice.pdf/download';
    //   }
    // },
    mounted () {
      if(this.$route.query.id) {
        this.getBooking();
      } else {
        console.log('no id provided');
      }
    },
    methods: {
        getBooking () {
            this.$root.loading = true
            fetch(this.$api + 'bookings/by_transaction/' + this.$route.query.id)
            .then(res => res.json())
            .then(response => {
                this.$root.loading = false
                this.payment = response.data
                this.booking = response.data.booking
            })
        },
        redirectMyBooking () {
            this.$router.push({ name: 'manage-booking' })
            $("html, body").animate({ scrollTop: 0 }, "slow");
        }
    }
  }
  </script>
  